import { GENERATED_FILES_QUERY_KEY } from "@frontend-shared/constants";
import type {
  IGeneratedFilesResponse,
  IGetGeneratedFilesParams,
} from "@frontend-shared/types";
import { isGeneratedFilesQueryOfScope } from "@frontend-shared/utils";
import { useQuery } from "@tanstack/react-query";

import { generatedFilesApi } from "@/api/services";

export { GENERATED_FILES_QUERY_KEY };

// NOTE: NSAI-4326 — the request itself (path, dropped-when-empty filters,
// default page size) lives in the shared `GeneratedFilesApi`, which the mobile
// screen calls too; this hook only owns the React Query wiring.
export const useGetGeneratedFiles = (
  props: IGetGeneratedFilesParams = {},
): ReturnType<typeof useQuery<IGeneratedFilesResponse>> => {
  const {
    scope = "mine",
    search,
    chatUuid,
    fileType,
    fromDate,
    toDate,
    page = 1,
    limit = 20,
  } = props;

  return useQuery({
    queryKey: [
      GENERATED_FILES_QUERY_KEY,
      { scope, search, chatUuid, fileType, fromDate, toDate, page, limit },
    ],
    queryFn: () =>
      generatedFilesApi.list({
        scope,
        search,
        chatUuid,
        fileType,
        fromDate,
        toDate,
        page,
        limit,
      }),
    placeholderData: (previousData, previousQuery) =>
      previousQuery !== undefined &&
      isGeneratedFilesQueryOfScope({
        queryKey: previousQuery.queryKey,
        scope,
      })
        ? previousData
        : undefined,
  });
};
